
export default class DeviceTransferForm {
    constructor() {
        this.initAutocomplete();
        this.lastQuery = '';
        this.activeRequest = null;
        this.isLoading = false;
        this.debounceTimer = null;
    }

    initAutocomplete() {
        this.nameInput = document.getElementById('device-transfer-item-name');
        if (!this.nameInput || this.nameInput.classList.contains('autocomplete-attached')) return;

        this.nameInput.classList.add('autocomplete-attached');
        this.suggestionsContainer = document.getElementById('suggestions-container-device') || this.createSuggestionsContainer();

        this.nameInput.addEventListener('click', () => {
            this.loadSuggestions(true);
        });

        this.nameInput.addEventListener('input', () => { // Changed keyup to input for better responsiveness
            this.loadSuggestions();
        });

        this.nameInput.addEventListener('keydown', event => {
            if (['ArrowDown', 'ArrowUp', 'Enter'].includes(event.key)) {
                this.handleKeyNavigation(event);
            }
        });

        this.nameInput.addEventListener('blur', () => {
            setTimeout(() => {
                this.suggestionsContainer.innerHTML = '';
                this.suggestionsContainer.style.display = 'none';
            }, 200);
        });
    }

    createSuggestionsContainer() {
        const container = document.createElement('div');
        container.id = 'suggestions-container';
        container.classList.add('list-group');
        container.style.position = 'absolute';
        container.style.zIndex = '9999';
        container.style.height = '35vh';
        document.body.appendChild(container);
        return container;
    }

    loadSuggestions(force = false) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            const query = this.nameInput.value;

            const provide = this.nameInput.getAttribute('data-provide');

            if ((query.length <= 1 && !force) || (query === this.lastQuery && !force) || this.isLoading) return;

            this.lastQuery = query;
            this.isLoading = true;
            if (this.activeRequest) this.activeRequest.abort();

            this.nameInput.classList.add('loading');

            const inputRect = this.nameInput.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const isBottomQuarter = inputRect.bottom > (viewportHeight * 0.60);

            if (isBottomQuarter) {
                this.suggestionsContainer.style.bottom = `${viewportHeight - (inputRect.top + window.scrollY)}px`;
                this.suggestionsContainer.style.top = 'auto';
            } else {
                this.suggestionsContainer.style.top = `${inputRect.bottom + window.scrollY}px`;
                this.suggestionsContainer.style.bottom = 'auto';
            }

            this.suggestionsContainer.style.left = `${inputRect.left + window.scrollX}px`;
            this.suggestionsContainer.style.width = `${inputRect.width}px`; // Match input width usually

            this.activeRequest = naja.makeRequest('POST', provide, { query: query }, { history: false })
                .then(response => {
                    this.displaySuggestions(response);
                })
                .catch(error => {
                    if (error.name !== 'AbortError') console.error(error);
                })
                .finally(() => {
                    this.nameInput.classList.remove('loading');
                    this.isLoading = false;
                    this.activeRequest = null;
                });
        }, 300);
    }

    displaySuggestions(suggestions) {
        this.suggestionsContainer.innerHTML = '';

        // Ensure suggestions is an array or object we can iterate
        const items = Array.isArray(suggestions) ? suggestions : Object.values(suggestions);

        if (items.length === 0) {
            this.suggestionsContainer.style.display = 'none';
            return;
        }

        this.suggestionsContainer.style.display = 'flex';
        this.suggestionsContainer.style.flexDirection = 'column';

        items.forEach((product, index) => {
            const item = document.createElement('a');
            item.classList.add('list-group-item', 'list-group-item-action');
            item.href = '#';
            item.style.cursor = 'pointer';

            // Highlight matching part
            const regex = new RegExp(`(${this.lastQuery})`, 'gi');
            const nameHtml = product.name.replace(regex, '<strong>$1</strong>');

            let html = `<div>${nameHtml}</div>`;
            if (product.serialNumber) {
                html += `<small class="text-muted">VČ: ${product.serialNumber}</small>`;
            }
            // Add more details if needed

            item.innerHTML = html;

            item.addEventListener('click', (e) => {
                e.preventDefault();
                this.selectItem(product);
            });

            this.suggestionsContainer.appendChild(item);
        });
    }

    selectItem(product) {
        // Populate fields
        this.nameInput.value = product.name;

        const storeCardInput = document.getElementById('device-transfer-item-store-card');
        if (storeCardInput) storeCardInput.value = product.id; // Assuming product.id is storeCardId

        const serialNumberInput = document.getElementById('device-transfer-item-serial-number');
        if (serialNumberInput) {
            serialNumberInput.value = product.serialNumber || '';
        }

        const deviceIdInput = document.getElementById('device-transfer-item-device-id-formated');
        if (deviceIdInput && product.deviceIdFormatted) {
            deviceIdInput.value = product.deviceIdFormatted;
        }

        this.suggestionsContainer.innerHTML = '';
        this.suggestionsContainer.style.display = 'none';
    }

    handleKeyNavigation(event) {
        if (this.suggestionsContainer.style.display !== 'flex') return;

        const items = this.suggestionsContainer.querySelectorAll('.list-group-item');
        if (items.length === 0) return;

        let highlighted = this.suggestionsContainer.querySelector('.active');
        let index = highlighted ? Array.from(items).indexOf(highlighted) : -1;

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            if (highlighted) highlighted.classList.remove('active');
            index = (index + 1) % items.length;
            items[index].classList.add('active');
            items[index].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            if (highlighted) highlighted.classList.remove('active');
            index = (index - 1 + items.length) % items.length;
            items[index].classList.add('active');
            items[index].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter') {
            if (highlighted) {
                event.preventDefault();
                highlighted.click();
            }
        }
    }
}

// Initialize when ready
document.addEventListener('DOMContentLoaded', () => {
    new DeviceTransferForm();
});

naja.addEventListener('complete', () => {
    new DeviceTransferForm();
});
